import { environment } from './../../../environments/environment';
import { Subject } from 'rxjs';
export class Global {
    public static apiUrl = localStorage.getItem('env') || environment.apiPRO;
    public static defaultEnv = new Subject<string>();
}
